import './static/scss/style.scss'
import DayNightMood from './layout/DayNightMood'

import Title from './components/Title'
import About from './components/About'
import EducationAndSkills from './components/Education&Skills'
import Services from './components/Services'
import Experience from './components/Experience'
import Header from './layout/Header'
import Contact from './components/Contact'
import Footer from './components/Footer'


export default function Home() {

  return (
   <>
   <Header />
   <main className="main-left pp-main-section">
      <Title />
      <About />
      <EducationAndSkills />
      <Experience />
      <Services />
      <Contact />
      <Footer />

   </main>
   <DayNightMood />
</>
  )
}
